import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { IoMenuSharp } from "react-icons/io5";
import { FaUserCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import AppSidebar from "./AppSidebar";
import { useAuth } from "../context/AuthContext";

/** Single shell for every signed-in user; the sidebar decides what admins see. */
const AppLayout: React.FC = () => {
  const { t } = useTranslation();
  const { profile } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [avatarError, setAvatarError] = useState(false);
  const profilePicture = profile?.profilePicture as string | undefined;

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <AppSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      <div className="lg:ml-64 flex flex-col min-h-screen">
        <header className="lg:hidden sticky top-0 z-20 flex items-center justify-between px-4 py-3 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center gap-2.5 min-w-0">
            <img
              src="/imgs/logo-128x128.png"
              alt=""
              width={40}
              height={40}
              className="w-10 h-10 rounded-xl shrink-0"
            />
            <h1 className="text-xl font-bold text-gray-800 dark:text-gray-100 truncate">
              Praisify
            </h1>
          </div>
          <div className="flex items-center gap-1">
            <Link
              to="/profile"
              className="p-1 rounded-full hover:bg-[#5932EA]/10 transition-colors"
              aria-label={t("profile")}
            >
              {profilePicture && !avatarError ? (
                <img
                  src={profilePicture}
                  alt=""
                  onError={() => setAvatarError(true)}
                  className="w-8 h-8 rounded-full object-cover ring-2 ring-gray-100 dark:ring-gray-700"
                />
              ) : (
                <FaUserCircle className="w-8 h-8 text-gray-400" />
              )}
            </Link>
            <button
              onClick={() => setIsSidebarOpen(true)}
              className="p-2 rounded-xl text-gray-600 dark:text-gray-400 hover:text-[#5932EA] hover:bg-[#5932EA]/10 transition-colors"
              aria-label={t("menu")}
            >
              <IoMenuSharp className="h-6 w-6" />
            </button>
          </div>
        </header>

        <main className="flex-1 p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
